export enum PortalTargets {
    HeaderButtons = 'header-buttons',
    HeaderSubTitle = 'header-sub-title',
    SidenavUtilitiesForSpecificReport = 'sidenav-utilities-for-specific-report'
}
